import { render, staticRenderFns } from "./UpdatePhone.vue?vue&type=template&id=985faa0c&scoped=true"
import script from "./UpdatePhone.vue?vue&type=script&lang=js"
export * from "./UpdatePhone.vue?vue&type=script&lang=js"
import style0 from "./UpdatePhone.vue?vue&type=style&index=0&id=985faa0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985faa0c",
  null
  
)

export default component.exports